export default __webpack_public_path__ + "static/media/banner2.300cea97.jpg";